<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="$t('product.product_add-registered-products')"
      :isFooter="true"
      :width="width"
      isCardColor="true"
    >
      <template #title="{ dialogTitle }">
        <span class="pl-5 py-2 dialogTitleStyle">
          {{ dialogTitle }}
        </span>
      </template>
      <div class="productInfo">
        <v-expansion-panels accordion multiple v-model="openPanelIndex">
          <v-data-table
            :items="pageProductList"
            :headers="headers"
            item-key="supplierId"
            group-by="supplierId"
            class="elevation-1 width100"
            :no-data-text="$t('common.common_not-register')"
            :items-per-page="-1"
            show-group-by
            hide-default-header
            hide-default-footer
          >
            <template v-slot:group="props">
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <template v-slot:actions>
                    <DisplaySwitchButton :open="isOpenPanelOpen(props.group)" />
                  </template>
                  <span class="header">
                    {{ props.items[0].supplierName }}
                  </span>
                </v-expansion-panel-header>
                <v-divider></v-divider>
                <v-expansion-panel-content>
                  <ProductTable
                    :headers="headers"
                    :items="props.items"
                    item-key="productId"
                    :search="productSearchInfo.keyword"
                    class="productTable"
                    :selectedCurrencyId="selectedPlatformCurrencyId"
                  >
                    <template v-slot:quantity="{ item }">
                      <v-text-field
                        v-model="item.quantity"
                        outlined
                        dense
                        hide-details
                        placeholder="0"
                        reverse
                      />
                    </template>
                    <template v-slot:price="{ item }">
                      <v-text-field
                        v-model="item.price"
                        outlined
                        dense
                        hide-details
                        placeholder="0"
                        reverse
                      />
                    </template>
                  </ProductTable>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </v-data-table>
        </v-expansion-panels>
      </div>
      <template #footer>
        <v-spacer> </v-spacer>
        <div class="ma-2 btnStyle">
          <NormalButton
            text="common.common_common_addition"
            textSize="16px"
            height="50px"
            width="100%"
            @click.native="complete()"
          />
        </div>
      </template>
    </DialogBase>
  </div>
</template>
<script>
import { NormalButton } from '@/components/items'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import _cloneDeep from 'lodash/cloneDeep'
import { mapGetters, mapActions } from 'vuex'
import { DisplaySwitchButton } from '@/components/items'
import ProductTable from './ProductTable'
import { platformUtil } from '@/util'

export default {
  components: {
    NormalButton,
    DialogBase,
    DisplaySwitchButton,
    ProductTable
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    jdRelatedProductData: {
      type: Array,
      require: false,
      default: () => []
    },
    selectedPlatform: {}
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 4,
      contentsCols: 7,
      inputItemHeight: '32px'
    },
    productSearchInfo: {
      category: ''
    },
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    registerJdRelatedProductData: [],
    selectedPlatformCurrencyId: '',
    headers: [
      {
        text: 'common.product_product-number',
        value: 'productNumber',
        sortable: false,
        align: 'center',
        width: '12%'
      },
      {
        text: 'common.product_product-name',
        value: 'productInfo',
        sortable: false,
        width: '35%'
      },
      {
        text: 'common.product_capacity',
        value: 'capacity',
        sortable: false,
        align: 'center',
        width: '10%'
      },
      {
        text: `product.product_purchase-price`,
        value: 'purchasePrice',
        sortable: false,
        align: 'end',
        width: '10%'
      },
      {
        text: 'sale.sale_purchase-price-rmb',
        value: 'purchasePriceCny',
        sortable: false,
        align: 'end',
        width: '10%'
      },
      {
        text: 'product.product_registration-quantity',
        value: 'quantity',
        sortable: false,
        width: '10%'
      },
      {
        text: 'common.common_register-price-cn',
        value: 'price',
        sortable: false,
        width: '12%'
      }
    ],
    productList: [],
    productListData: [],

    errDialog: false
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    async init() {
      if (this.selectedPlatform.value) {
        const platform = platformUtil.getPlatformById(
          this.selectedPlatform.value
        )
        this.selectedPlatformCurrencyId =
          platformUtil.getCurrencyIdByPlatformCurrencyId(
            platform.platformCountryId
          )
        switch (platform.platformCountryId) {
          case 33: // 中国
            this.headers[4].text = 'sale.sale_purchase-price-rmb'
            this.headers[6].text = 'common.common_register-price-cn'
            break
          case 88: // 日本
            this.headers[4].text = 'sale.sale_purchase-price-jpn'
            this.headers[6].text = 'common.common_register-price-ja'
            break
        }
      }
      await this.createProductListData()
      this.setGroupNames()
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    async createProductListData() {
      await this.getProductListFromApi()
      this.productList = this.getProductListFromState()

      await this.getSuppliersFromApi()
      this.pageProductList = this.productList.map((ele) => {
        ele.supplierName = this.getSupplierName(ele.supplierId)
        ele.productInfo = `${ele.nameJp}\n${ele.nameCn}`
        // this.jdRelatedProductData.productIdと合致するものがあった場合、
        // ele.quantityとele.priceを追加する
        const jdRelatedProduct = this.jdRelatedProductData.find(
          (element) => element.productId === ele.productId
        )
        if (jdRelatedProduct) {
          ele.quantity = jdRelatedProduct.quantity
          ele.price = jdRelatedProduct.price
        }

        return ele
      })
    },
    isName(header, name) {
      return header.value === name
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },

    complete() {
      // this.pageProductList.price && this.pageProductList.quantity が存在するものだけ
      // registerJdRelatedProductDataList に値を代入する
      const registerJdRelatedProductDataList = this.pageProductList.filter(
        (product) => {
          return product.price && product.quantity
        }
      )
      // JD関連商品の配列をフォーマットする処理
      if (registerJdRelatedProductDataList) {
        this.registerJdRelatedProductData =
          registerJdRelatedProductDataList.map((ele) => {
            return {
              productId: ele.productId,
              product: ele,
              quantity: ele.quantity,
              price: ele.price
            }
          })
      }
      this.$emit('complete', this.registerJdRelatedProductData)
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    },
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.btnStyle {
  width: 130px;
}
.dialogTitleStyle {
  font-size: 22px;
}

.productInfo {
  .header {
    order: 1;
  }
  .width100 {
    width: 100%;
  }
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0;
  }
  .productTable {
    ::v-deep .v-data-table th {
      background-color: rgba(151, 198, 234, 0.1) !important;
      border-collapse: collapse;
      white-space: pre-wrap;
      word-wrap: break-word;

      border-bottom: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
    }
    ::v-deep .v-data-table td {
      background-color: #f6f6f6;
      border-collapse: collapse;

      border-bottom: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-spacing: 0;
      margin: -1px;
    }
    ::v-deep .v-data-table tr:nth-child(odd) td {
      background-color: rgba(213, 213, 213, 0.1);
      border-collapse: collapse;
      border-bottom: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-spacing: 0;
      margin: -1px;
    }
    ::v-deep .v-data-table tr:hover td {
      background-color: #eee;
    }
  }
}
</style>
